/**
 * Styles pour l'en-tête de chat
 * Design moderne inspiré de la landing page avec moins d'arrondis
 */
export const CHAT_HEADER_STYLES = `
  /* Header */
  .ringado-chat-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px; /* Padding plus compact */
    border-bottom: 1px solid #e5e7eb;
    background: white;
    border-radius: 12px 12px 0 0;
    position: relative;
    min-height: 44px; /* Hauteur réduite pour plus de compacité */
    flex-shrink: 0;
    /* Ombre subtile pour définir la séparation */
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  }

  .ringado-chat-header .status-info {
    display: flex;
    align-items: center;
    gap: 8px; /* Gap plus compact */
    flex: 1;
    min-width: 0;
  }

  .status-text-container {
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1;
    min-width: 0;
  }

  .ringado-status-dot {
    width: 8px; /* Dot plus petit */
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    position: relative;
  }

  .ringado-status-dot.connected {
    background: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
  }

  .ringado-status-dot.viewing {
    background: #f59e0b;
    animation: ringado-pulse 2s ease-in-out infinite;
    box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.15);
  }

  .ringado-status-dot.assistant {
    background: #10b981;
    box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.15);
  }

  .ringado-chat-header .status-text {
    font-size: 14px; /* Taille de police plus compacte */
    font-weight: 500;
    color: #111827;
    letter-spacing: -0.025em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
    /* Style plus épuré, inspiré de la landing */
  }

  .ringado-chat-header .status-badges {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .ringado-chat-header .status-badge {
    font-size: 11px;
    padding: 3px 8px;
    border-radius: 6px; /* Moins arrondi */
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    line-height: 1.2;
    white-space: nowrap;
  }

  .ringado-chat-header .status-badge.live {
    color: #1e40af;
    background: #dbeafe;
    border: 1px solid rgba(30, 64, 175, 0.1);
  }

  .ringado-chat-header .status-badge.viewing {
    color: #b45309;
    background: #fef3c7;
    border: 1px solid rgba(180, 83, 9, 0.1);
    animation: ringado-pulse 2s ease-in-out infinite;
  }

  /* Live badge - Design monochrome minimaliste */
  .ringado-live-badge {
    font-size: 10px;
    font-weight: 600;
    color: #6b7280;
    background: rgba(107, 114, 128, 0.08);
    border: 1px solid rgba(107, 114, 128, 0.12);
    padding: 2px 6px;
    border-radius: 4px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    line-height: 1;
    white-space: nowrap;
    transition: all 0.2s ease;
  }

  .ringado-close-button {
    padding: 6px; /* Padding plus compact */
    border: none;
    background: none;
    border-radius: 4px; /* Plus petit et moins arrondi */
    cursor: pointer;
    color: #9ca3af;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px; /* Taille plus compacte */
    height: 26px;
    flex-shrink: 0;
    margin-left: 8px; /* Marge plus compacte */
  }

  .ringado-close-button:hover {
    background: #f3f4f6;
    color: #6b7280;
    transform: scale(1.05);
  }

  .ringado-close-button:active {
    transform: scale(0.95);
    background: #e5e7eb;
  }

  /* Responsive adjustments */
  @media (max-width: 480px) {
    .ringado-chat-header {
      padding: 10px 12px;
      min-height: 50px;
    }
    
    .ringado-chat-header .status-text {
      font-size: 13px;
    }
    
    .ringado-status-dot {
      width: 6px;
      height: 6px;
    }
    
    .ringado-close-button {
      width: 24px;
      height: 24px;
      padding: 4px;
    }
  }

  /* Animation pour le pulse */
  @keyframes ringado-pulse {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.8;
      transform: scale(1.05);
    }
  }
`;
